import { render } from "./micDetector.vue?vue&type=template&id=fd4931c4&scoped=true"
import script from "./micDetector.vue?vue&type=script&lang=js"
export * from "./micDetector.vue?vue&type=script&lang=js"

import "./index.scss?vue&type=style&index=0&id=fd4931c4&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd4931c4"]])

export default __exports__